module.exports = __webpack_public_path__ + "img/front_neck_depth.f29c0423.png";